import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/event-types",
  action: async () => {
    const c = await import("./views/eventTypes.vue");
    return h(c.default);
  },
};

export default route;
